import * as stringReplace from "./stringReplace";
import { IStringUtils } from "../";
const stringU: IStringUtils = {
  ...stringReplace,
};
const { replaceInvalidChars, lowerCaseExtension } = stringReplace;
export { replaceInvalidChars, lowerCaseExtension };
export default stringU;
